import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import { Touch } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  directives: {
    Touch
  }
})

import colors from 'vuetify/lib/util/colors'
// const themeCache = new LRU({
//   max: 10,
//   maxAge: 1000 * 60 * 60, // 1 hour
// })

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: true,
    default: 'dark',
    themes: {
      dark: {
        accent: colors.blue.lighten2,
      },
    },
    options: {
      minifyTheme: function (css) {
        return process.env.NODE_ENV === 'production'
          ? css.replace(/[\r\n|\r|\n]/g, '')
          : css
      },
      // themeCache,
    },
  },
})